// @ts-nocheck
// ui — Pilotools base components & icons (Lucide-style stroke icons)
// Ported verbatim from the design bundle (pilotools-crm/project/ui.jsx).
// The window.* global-bag model is preserved: ./runtime sets the config
// globals (WORK_HOURS, STAGES, …) this module reads.
import React from 'react';
import { t } from './i18n';
import './runtime';

const { useState, useEffect, useRef, useMemo, useCallback, createContext, useContext } = React;

// ─────────────────────────────────────────────────────────────────────────────
// Icons — Lucide-style, stroke 1.75, currentColor
// ─────────────────────────────────────────────────────────────────────────────
const Ic = ({ d, size = 20, sw = 1.75, fill = 'none', viewBox = '0 0 24 24', children, style }) => (
  <svg width={size} height={size} viewBox={viewBox} fill={fill}
       stroke="currentColor" strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round"
       style={{ display: 'block', flexShrink: 0, ...style }}>
    {d ? <path d={d} /> : children}
  </svg>
);

const Icon = {
  Phone:    (p) => <Ic {...p}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.33 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/></Ic>,
  PhoneOff: (p) => <Ic {...p}><path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67M2 2l20 20M16.7 9.3a16 16 0 0 0-3.42-2.61L13 5"/></Ic>,
  PhoneMissed: (p) => <Ic {...p}><line x1="22" y1="2" x2="16" y2="8"/><line x1="16" y1="2" x2="22" y2="8"/><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></Ic>,
  Mail:     (p) => <Ic {...p}><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></Ic>,
  Send:     (p) => <Ic {...p}><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></Ic>,
  MessageCircle: (p) => <Ic {...p}><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></Ic>,
  MessageSquare: (p) => <Ic {...p}><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></Ic>,
  Check:    (p) => <Ic {...p} d="M20 6 9 17l-5-5"/>,
  X:        (p) => <Ic {...p}><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></Ic>,
  Clock:    (p) => <Ic {...p}><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></Ic>,
  Alert:    (p) => <Ic {...p}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="13"/><line x1="12" y1="16" x2="12.01" y2="16"/></Ic>,
  AlertTri: (p) => <Ic {...p}><path d="m10.29 3.86-8.39 14a2 2 0 0 0 1.71 3h16.78a2 2 0 0 0 1.71-3l-8.39-14a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></Ic>,
  Bell:     (p) => <Ic {...p}><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></Ic>,
  Sparkle:  (p) => <Ic {...p}><path d="m12 3-1.9 5.8a2 2 0 0 1-1.3 1.3L3 12l5.8 1.9a2 2 0 0 1 1.3 1.3L12 21l1.9-5.8a2 2 0 0 1 1.3-1.3L21 12l-5.8-1.9a2 2 0 0 1-1.3-1.3L12 3z"/></Ic>,
  ArrowLeft:(p) => <Ic {...p}><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></Ic>,
  ArrowRight:(p) => <Ic {...p}><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></Ic>,
  ArrowUp:  (p) => <Ic {...p}><line x1="12" y1="19" x2="12" y2="5"/><polyline points="5 12 12 5 19 12"/></Ic>,
  ArrowDown:(p) => <Ic {...p}><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></Ic>,
  Trend:    (p) => <Ic {...p}><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></Ic>,
  TrendDn:  (p) => <Ic {...p}><polyline points="22 17 13.5 8.5 8.5 13.5 2 7"/><polyline points="16 17 22 17 22 11"/></Ic>,
  More:     (p) => <Ic {...p}><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></Ic>,
  Search:   (p) => <Ic {...p}><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></Ic>,
  Filter:   (p) => <Ic {...p}><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></Ic>,
  Plus:     (p) => <Ic {...p}><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></Ic>,
  User:     (p) => <Ic {...p}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></Ic>,
  Users:    (p) => <Ic {...p}><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></Ic>,
  Home:     (p) => <Ic {...p}><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></Ic>,
  Today:    (p) => <Ic {...p}><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/><circle cx="12" cy="15" r="1.5" fill="currentColor"/></Ic>,
  Briefcase:(p) => <Ic {...p}><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></Ic>,
  Fire:     (p) => <Ic {...p}><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/></Ic>,
  Eye:      (p) => <Ic {...p}><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></Ic>,
  EyeOff:   (p) => <Ic {...p}><path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"/><path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"/><path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"/><line x1="2" y1="2" x2="22" y2="22"/></Ic>,
  Chevron:  (p) => <Ic {...p}><polyline points="9 18 15 12 9 6"/></Ic>,
  ChevronDown:(p)=> <Ic {...p}><polyline points="6 9 12 15 18 9"/></Ic>,
  ChevronUp:(p) => <Ic {...p}><polyline points="18 15 12 9 6 15"/></Ic>,
  Refresh:  (p) => <Ic {...p}><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/></Ic>,
  Settings: (p) => <Ic {...p}><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/></Ic>,
  LogOut:   (p) => <Ic {...p}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></Ic>,
  Instagram:(p) => <Ic {...p}><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></Ic>,
  Telegram: (p) => <Ic {...p}><path d="M22 2 11 13"/><path d="M22 2 15 22 11 13 2 9z"/></Ic>,
  Reply:    (p) => <Ic {...p}><polyline points="9 17 4 12 9 7"/><path d="M20 18v-2a4 4 0 0 0-4-4H4"/></Ic>,
  Cloud:    (p) => <Ic {...p}><path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"/></Ic>,
  CloudOff: (p) => <Ic {...p}><path d="M22.61 16.95A5 5 0 0 0 18 10h-1.26a8 8 0 0 0-7.05-6M5 5a8 8 0 0 0 4 15h9a5 5 0 0 0 1.7-.3M2 2l20 20"/></Ic>,
  Globe:    (p) => <Ic {...p}><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></Ic>,
  Star:     (p) => <Ic {...p}><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></Ic>,
  Link:     (p) => <Ic {...p}><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></Ic>,
  CircleDot:(p) => <Ic {...p}><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="3" fill="currentColor"/></Ic>,
  Calendar: (p) => <Ic {...p}><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></Ic>,
  ExternalLink:(p)=><Ic {...p}><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></Ic>,
  Layers:   (p) => <Ic {...p}><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></Ic>,
  PieChart: (p) => <Ic {...p}><path d="M21.21 15.89A10 10 0 1 1 8 2.83"/><path d="M22 12A10 10 0 0 0 12 2v10z"/></Ic>,
  BarChart: (p) => <Ic {...p}><line x1="12" y1="20" x2="12" y2="10"/><line x1="18" y1="20" x2="18" y2="4"/><line x1="6" y1="20" x2="6" y2="16"/></Ic>,
  Headset:  (p) => <Ic {...p}><path d="M3 18v-6a9 9 0 0 1 18 0v6"/><path d="M21 19a2 2 0 0 1-2 2h-1v-7h3zM3 19a2 2 0 0 0 2 2h1v-7H3z"/></Ic>,
  Mic:      (p) => <Ic {...p}><path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></Ic>,
  Recycle:  (p) => <Ic {...p}><path d="M7 19H4.815a1.83 1.83 0 0 1-1.57-.881 1.785 1.785 0 0 1-.004-1.784L7.196 9.5"/><path d="M11 19h8.203a1.83 1.83 0 0 0 1.556-.89 1.784 1.784 0 0 0 0-1.775l-1.226-2.12"/><path d="m14 16-3 3 3 3"/><path d="M8.293 13.596 7.196 9.5 3.1 10.598"/><path d="m9.344 5.811 1.093-1.892A1.83 1.83 0 0 1 11.985 3a1.784 1.784 0 0 1 1.546.888l3.943 6.843"/><path d="m13.378 9.633 4.096 1.098 1.097-4.096"/></Ic>,
  Heart:    (p) => <Ic {...p}><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></Ic>,
  Brain:    (p) => <Ic {...p}><path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2z"/><path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2z"/></Ic>,
  Target:   (p) => <Ic {...p}><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></Ic>,
  Activity: (p) => <Ic {...p}><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></Ic>,
  ListTodo: (p) => <Ic {...p}><rect x="3" y="5" width="6" height="6" rx="1"/><path d="m3 17 2 2 4-4"/><path d="M13 6h8"/><path d="M13 12h8"/><path d="M13 18h8"/></Ic>,
  Trash:    (p) => <Ic {...p}><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></Ic>,
};

// ─────────────────────────────────────────────────────────────────────────────
// Avatar — initials with deterministic color
// ─────────────────────────────────────────────────────────────────────────────
const AVATAR_COLORS = ['#0F3D6E','#1E5DA8','#4A90D9','#6B5BD2','#1FA971','#E0A030','#D63B3B','#3A4554','#5A6478'];
function Avatar({ name = '?', size = 32 }) {
  const initials = name.split(/\s+/).map(n => n[0]).slice(0, 2).join('').toUpperCase();
  const hash = name.split('').reduce((a, c) => a + c.charCodeAt(0), 0);
  const bg = AVATAR_COLORS[hash % AVATAR_COLORS.length];
  return (
    <span className={`avatar avatar-${size}`} style={{ background: bg, width: size, height: size, fontSize: size * 0.4 }}>
      {initials}
    </span>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// Buttons / Badges / Cards as light wrappers
// ─────────────────────────────────────────────────────────────────────────────
function Button({ variant = 'primary', size = 'md', full, icon, children, onClick, style }) {
  const cls = ['btn', `btn-${variant}`, size !== 'md' && `btn-${size}`, full && 'btn-full'].filter(Boolean).join(' ');
  return <button className={cls} onClick={onClick} style={style}>{icon}{children}</button>;
}

function IconButton({ icon, active, size = 40, onClick, style, label }) {
  return (
    <button className={`ibtn ${size === 32 ? 'ibtn-sm' : ''} ${active ? 'ibtn-active' : ''}`}
            onClick={onClick} style={style} aria-label={label}>
      {icon}
    </button>
  );
}

function Badge({ tone = 'neutral', dot, sm, children, style }) {
  return <span className={`badge badge-${tone} ${dot ? 'badge-dot' : ''} ${sm ? 'badge-sm' : ''}`} style={style}>{children}</span>;
}

// Status badge (locked color by status)
function StatusBadge({ status }) {
  const map = {
    pending:  { tone: 'neutral', key: 'st.pending' },
    duesoon:  { tone: 'warning', key: 'st.duesoon' },
    overdue:  { tone: 'danger',  key: 'st.overdue' },
    done:     { tone: 'success', key: 'st.done' },
  };
  const m = map[status] || map.pending;
  return <Badge tone={m.tone} dot>{t(m.key)}</Badge>;
}

// Deadline timer (live ticking)
function DeadlineTimer({ deadlineMin, live = true }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!live) return;
    const i = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(i);
  }, [live]);
  // deadlineMin: minutes from "now" — positive=future, negative=overdue
  const min = deadlineMin;
  const isOverdue = min < 0;
  const tone = isOverdue ? 'timer-overdue' : (Math.abs(min) <= 30 ? 'timer-soon' : 'timer-normal');
  const abs = Math.abs(min);
  const h = Math.floor(abs / 60);
  const m = abs % 60;
  const txt = h ? `${h}ч ${m}м` : `${m}м`;
  return (
    <span className={`timer ${tone}`}>
      <Icon.Clock size={14} sw={2} />
      {isOverdue ? `Просрочено ${txt}` : `До дедлайна ${txt}`}
    </span>
  );
}

// AI inline card
function AIInline({ children, label = 'AI-подсказка' }) {
  return (
    <div className="ai-inline">
      <Icon.Sparkle size={18} style={{ color: 'var(--ai)' }} />
      <div className="ai-inline-body">
        <div className="ai-inline-label">{label}</div>
        <div className="ai-inline-text">{children}</div>
      </div>
    </div>
  );
}

// Sparkline (24px tall)
function Sparkline({ data = [3, 5, 4, 7, 6, 9, 8], color = 'var(--brand-500)', width = 60, height = 24 }) {
  const max = Math.max(...data, 1);
  const min = Math.min(...data, 0);
  const range = max - min || 1;
  const dx = width / (data.length - 1);
  const points = data.map((v, i) => `${i * dx},${height - ((v - min) / range) * (height - 4) - 2}`).join(' ');
  return (
    <svg className="spark" width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      <polyline points={points} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

// Logo mark (inline SVG of the cloud+gear shape)
function LogoMark({ size = 24, color }) {
  const cloudColor = color || 'var(--brand-500)';
  const darkColor = color || 'var(--brand-900)';
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
      {/* Cloud body */}
      <path d="M9 16c-3 0-5 2-5 4.5S6 25 9 25h14c3 0 5-2 5-4.5 0-2.2-1.6-4-3.8-4.4-.4-3.5-3.4-6.1-7-6.1-2.8 0-5.3 1.7-6.3 4.2C10.4 14 9.7 14.5 9 15v1z" fill={cloudColor}/>
      {/* Connection dots */}
      <line x1="12" y1="25" x2="12" y2="28" stroke={cloudColor} strokeWidth="1.5"/>
      <line x1="16" y1="25" x2="16" y2="30" stroke={cloudColor} strokeWidth="1.5"/>
      <line x1="20" y1="25" x2="20" y2="28" stroke={cloudColor} strokeWidth="1.5"/>
      <circle cx="12" cy="29" r="1.3" fill={cloudColor}/>
      <circle cx="16" cy="30" r="1.3" fill={cloudColor}/>
      <circle cx="20" cy="29" r="1.3" fill={cloudColor}/>
      {/* Gear (simplified) */}
      <g transform="translate(15.5 14.5)">
        <circle r="3.2" fill="#fff"/>
        <g fill="#fff">
          <rect x="-0.7" y="-4.5" width="1.4" height="2" rx="0.3"/>
          <rect x="-0.7" y="2.5" width="1.4" height="2" rx="0.3"/>
          <rect x="-4.5" y="-0.7" width="2" height="1.4" rx="0.3"/>
          <rect x="2.5" y="-0.7" width="2" height="1.4" rx="0.3"/>
        </g>
        <circle r="1.2" fill={cloudColor}/>
      </g>
    </svg>
  );
}

// Telegram Mini App header (Pilotools)
function MiniHeader({ title, leftIcon, rightIcon, onLeft, onRight, showLogo, notif }) {
  return (
    <div className="miniheader">
      {showLogo ? (
        <LogoMark size={24} />
      ) : leftIcon ? (
        <button className="ibtn ibtn-sm" onClick={onLeft} style={{ background: 'transparent' }}>{leftIcon}</button>
      ) : <div className="miniheader-spacer" />}
      <div className="miniheader-title">{title}</div>
      {rightIcon ? (
        <button className="ibtn ibtn-sm" onClick={onRight} style={{ background: 'transparent', position: 'relative' }}>
          {rightIcon}
          {notif && <span style={{ position: 'absolute', top: 4, right: 4, width: 8, height: 8, borderRadius: '50%', background: 'var(--danger)', border: '2px solid var(--surface)' }} />}
        </button>
      ) : <div className="miniheader-spacer" />}
    </div>
  );
}

// Section header with optional count
function SectionHeader({ children, count, action, tone }) {
  return (
    <div className="sec-header">
      <div className="row middle gap-2">
        <span className="t-label" style={tone === 'danger' ? { color: 'var(--danger)' } : tone === 'warning' ? { color: 'var(--warning)' } : undefined}>{children}</span>
        {count !== undefined && (
          <span className="sec-count" style={tone === 'danger' ? { background: 'var(--danger-bg)', color: 'var(--danger)' } : undefined}>{count}</span>
        )}
      </div>
      {action}
    </div>
  );
}

// Sticky action bar (inside scroll area)
function ActionBar({ children }) {
  return <div className="action-bar">{children}</div>;
}

// Bottom nav
function BottomNav({ items, active, onChange }) {
  return (
    <nav className="botnav">
      {items.map((it) => (
        <button key={it.key}
                className={`botnav-item ${active === it.key ? 'is-active' : ''}`}
                onClick={() => onChange(it.key)}>
          <span style={{ position: 'relative', display: 'inline-flex' }}>
            {it.icon}
            {it.badge ? (
              <span style={{
                position: 'absolute', top: -4, right: -7, minWidth: 16, height: 16, padding: '0 4px',
                borderRadius: 100, background: 'var(--danger)', color: '#fff',
                font: '700 10px/16px var(--font-sans)', textAlign: 'center',
                border: '2px solid var(--surface)', boxSizing: 'content-box',
              }}>{it.badge}</span>
            ) : null}
          </span>
          <span>{it.labelKey ? t(it.labelKey) : it.label}</span>
        </button>
      ))}
    </nav>
  );
}

// Escalation badge
function EscBadge({ level }) {
  return <span className={`esc esc-L${level}`}>L{level}</span>;
}

// Intent dot
function IntentDot({ intent }) {
  const map = { hot: 'dot-hot', warm: 'dot-warm', cold: 'dot-cold', thinking: 'dot-thinking', noanswer: 'dot-noanswer' };
  return <span className={`dot ${map[intent] || 'dot-cold'}`} />;
}

function IntentBadge({ intent }) {
  const map = {
    hot:     { color: 'var(--danger)',  bg: 'var(--danger-bg)',  key: 'intent.hot' },
    warm:    { color: 'var(--warning)', bg: 'var(--warning-bg)', key: 'intent.warm' },
    cold:    { color: 'var(--brand-500)', bg: 'var(--brand-100)', key: 'intent.cold' },
    noanswer:{ color: 'var(--ai)',      bg: 'var(--ai-bg)',      key: 'intent.noanswer' },
    thinking:{ color: 'var(--text-2)',  bg: 'var(--surface-2)',  key: 'intent.thinking' },
  };
  const m = map[intent] || map.cold;
  return (
    <span className="badge badge-dot" style={{ color: m.color, background: m.bg }}>
      {t(m.key)}
    </span>
  );
}

// Channel icon — only integrated channels: telegram, telegram_business, instagram, call
function SourceIcon({ source, size = 16 }) {
  const map = {
    instagram:         { ic: <Icon.Instagram size={size} />, color: '#E1306C' },
    telegram:          { ic: <Icon.Telegram size={size} />,  color: '#229ED9' },
    telegram_business: { ic: <Icon.Telegram size={size} />,  color: '#2AABEE' },
    call:              { ic: <Icon.Phone size={size} />,     color: 'var(--success)' },
  };
  const m = map[source] || map.telegram;
  return <span style={{ color: m.color, display: 'inline-flex' }}>{m.ic}</span>;
}

const CHANNEL_LABEL = {
  telegram: 'Telegram (бот)',
  telegram_business: 'Telegram Business',
  instagram: 'Instagram Direct',
  call: 'Телефония',
};

// ── Money formatter: UZS primary, USD secondary ──────────────────────
function fmtUzs(n) {
  return n.toLocaleString('ru-RU').replace(/,/g, '\u00A0');
}
function Money({ uzs, size = 'inline', usd = true }) {
  const dollars = Math.round(uzs / (window.USD_RATE || 12600));
  if (size === 'block') {
    return (
      <span style={{ display: 'inline-flex', flexDirection: 'column', lineHeight: 1.15 }}>
        <span className="t-body-s">{`${fmtUzs(uzs)}\u00A0сум`}</span>
        {usd && <span className="t-caption" style={{ color: 'var(--text-3)' }}>≈ ${dollars.toLocaleString('en-US')}</span>}
      </span>
    );
  }
  return (
    <span>
      {`${fmtUzs(uzs)}\u00A0сум`}{usd && <span style={{ color: 'var(--text-3)', fontWeight: 400 }}> · ${dollars.toLocaleString('en-US')}</span>}
    </span>
  );
}

// ── Stage chip (Bitrix uzbek label + ru sub, star for TG-MALUMOT) ────
// `stage` is the raw STAGE_ID. `label`/`pipeline` come from the backend
// StageRef (resolved from tenant_pipelines) and cover EVERY funnel — the
// hardcoded window.STAGES map only knows the default funnel, so we prefer the
// backend label and fall back to the map for star/desc decoration only.
function StageChip({ stage, label, pipeline, showRu = false, showPipeline = false, style }) {
  const S = (window.STAGES || {})[stage] || {};
  const text = label || S.label || stage;
  const desc = S.descKey ? t(S.descKey) : (S.ru || '');
  const pipe = showPipeline && pipeline && pipeline !== text ? pipeline : '';
  return (
    <span className="chip" style={{
      background: S.star ? 'var(--brand-100)' : 'var(--surface-2)',
      color: S.star ? 'var(--brand-900)' : 'var(--text-2)',
      ...style,
    }}>
      {S.star && <Icon.Sparkle size={11} sw={2.5} style={{ color: 'var(--brand-500)' }} />}
      {pipe && <span style={{ color: 'var(--text-3)', fontWeight: 600 }}>{pipe} · </span>}
      <span style={{ fontWeight: 600 }}>{text}</span>
      {showRu && desc && <span style={{ color: 'var(--text-3)', fontWeight: 400 }}>· {desc}</span>}
    </span>
  );
}

// ── Agent (task creator) badge ───────────────────────────────────────
function AgentBadge({ source, time }) {
  const label = (window.AGENT_LABEL || {})[source] || source;
  const isAI = ['telegram_analyst', 'call_analyst', 'watcher', 'reactivation'].includes(source);
  return (
    <span className="row middle gap-1" style={{ display: 'inline-flex' }}>
      {isAI && <Icon.Sparkle size={12} sw={2.5} style={{ color: 'var(--ai)' }} />}
      <span className="t-caption-s" style={{ color: isAI ? 'var(--ai)' : 'var(--text-2)' }}>{label}</span>
      {time && <span className="t-caption" style={{ color: 'var(--text-3)' }}>· {time}</span>}
    </span>
  );
}

// ── Tone badge (AI contract: positive/neutral/negative/irritated) ────
function ToneBadge({ tone }) {
  const map = {
    positive:  { key: 'tone.positive',  tone: 'success' },
    neutral:   { key: 'tone.neutral',   tone: 'neutral' },
    negative:  { key: 'tone.negative',  tone: 'warning' },
    irritated: { key: 'tone.irritated', tone: 'danger' },
  };
  const m = map[tone] || map.neutral;
  return <Badge tone={m.tone} sm>{t(m.key)}</Badge>;
}

// ── Work-hours aware greeting line (Asia/Tashkent, lunch 13:00-13:30) ─
// nowMin: minutes since midnight. Returns {phase, text}
function workdayStatus(nowMin, wh) {
  const W = wh || window.WORK_HOURS || {};
  const toMin = (s) => { const [h, m] = s.split(':').map(Number); return h * 60 + m; };
  const start = toMin(W.start || '10:00'), end = toMin(W.end || '17:00');
  const ls = toMin(W.lunchStart || '13:00'), le = toMin(W.lunchEnd || '13:30');
  const fmt = (mins) => { const h = Math.floor(mins / 60), m = mins % 60; return h ? `${h}${t('unit.h')} ${m}${t('unit.m')}` : `${m} ${t('unit.min')}`; };
  if (nowMin < start) return { phase: 'before', text: t('work.before', { t: W.start }) };
  if (nowMin >= end) return { phase: 'after', text: t('work.after') };
  if (nowMin >= ls && nowMin < le) return { phase: 'lunch', text: t('work.lunch', { a: W.lunchStart, b: W.lunchEnd, t: fmt(le - nowMin) }) };
  if (nowMin < ls) return { phase: 'morning', text: t('work.morning', { t: fmt(ls - nowMin), a: W.lunchStart, b: W.lunchEnd }) };
  return { phase: 'afternoon', text: t('work.afternoon', { t: fmt(end - nowMin) }) };
}

// ── Manager name resolver ────────────────────────────────────────────
function mgrName(id, short) {
  const m = (window.MANAGERS || {})[id];
  if (!m) return '—';
  return short ? m.short : m.name;
}

// ── Funnel selector (compact dropdown) ───────────────────────────────
function FunnelSelector({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const funnels = window.FUNNELS || [];
  const cur = funnels.find(f => f.id === value) || funnels[0];
  return (
    <div style={{ position: 'relative' }}>
      <button onClick={() => setOpen(!open)}
        style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '7px 10px', borderRadius: 8,
                 background: 'var(--surface-2)', border: 'none', cursor: 'pointer', maxWidth: '100%' }}>
        <Icon.Layers size={15} sw={2} style={{ color: 'var(--brand-500)', flexShrink: 0 }} />
        <span className="t-caption-s" style={{ color: 'var(--text-1)' }}>{cur.label}</span>
        {cur.ai === 'active' && <span className="badge badge-ai badge-sm" style={{ padding: '1px 5px' }}>AI</span>}
        <Icon.ChevronDown size={14} sw={2.5} style={{ color: 'var(--text-3)' }} />
      </button>
      {open && (
        <>
          <div style={{ position: 'fixed', inset: 0, zIndex: 19 }} onClick={() => setOpen(false)} />
          <div className="card card-strong" style={{ position: 'absolute', top: 'calc(100% + 6px)', left: 0, zIndex: 20, width: 260, padding: 6, maxHeight: 360, overflowY: 'auto' }}>
            {funnels.map(f => (
              <button key={f.id} onClick={() => { onChange(f.id); setOpen(false); }}
                style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%', padding: '9px 10px', borderRadius: 8,
                         background: f.id === value ? 'var(--surface-2)' : 'transparent', border: 'none', cursor: 'pointer', textAlign: 'left' }}>
                <div className="flex-1" style={{ minWidth: 0 }}>
                  <div className="t-body-s" style={{ lineHeight: 1.2 }}>{f.label}</div>
                  {f.sub && <div className="t-caption">{f.sub}</div>}
                </div>
                {f.ai === 'active'
                  ? <span className="badge badge-ai badge-sm">AI активен</span>
                  : <span className="badge badge-neutral badge-sm" style={{ color: 'var(--text-3)' }}>⏳ Скоро</span>}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

// Skeleton block
function Skel({ w, h = 14, r = 6, style }) {
  return <div className="skel" style={{ width: w, height: h, borderRadius: r, ...style }} />;
}

// Empty state
function EmptyState({ icon, title, hint, action }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', padding: '48px 24px', gap: 12 }}>
      <div style={{ width: 72, height: 72, borderRadius: 18, background: 'var(--surface-2)', color: 'var(--text-3)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {icon}
      </div>
      <div className="t-h2" style={{ marginTop: 4 }}>{title}</div>
      {hint && <div className="t-caption" style={{ maxWidth: 280 }}>{hint}</div>}
      {action && <div style={{ marginTop: 8 }}>{action}</div>}
    </div>
  );
}

// Toggle (iOS-style)
function Toggle({ value, onChange }) {
  return (
    <button onClick={() => onChange(!value)}
      style={{
        width: 44, height: 26, borderRadius: 13,
        background: value ? 'var(--success)' : 'var(--border-strong)',
        position: 'relative', border: 'none', cursor: 'pointer',
        transition: 'background 0.2s',
        flexShrink: 0,
      }}>
      <span style={{
        position: 'absolute', top: 2, left: value ? 20 : 2,
        width: 22, height: 22, borderRadius: '50%',
        background: '#fff',
        boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
        transition: 'left 0.2s',
      }} />
    </button>
  );
}

export {
  Icon, Avatar, Button, IconButton, Badge, StatusBadge, DeadlineTimer,
  AIInline, Sparkline, LogoMark, MiniHeader, SectionHeader, ActionBar,
  BottomNav as BottomNavBase, EscBadge, IntentDot, IntentBadge, SourceIcon, Skel, EmptyState, Toggle,
  CHANNEL_LABEL, Money, fmtUzs, StageChip, AgentBadge, ToneBadge,
  workdayStatus, mgrName, FunnelSelector,
};
